import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "../../styles/legal.css";

const LOGO_URL = "/logo-cropped.png";

// Every page the app stores link to. Shown in the footer of each legal page.
export const LEGAL_LINKS = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms and Conditions", to: "/terms" },
  { label: "Community Guidelines", to: "/community-guidelines" },
  { label: "Child Safety Standards", to: "/child-safety" },
  { label: "Delete Account", to: "/delete-account" },
  { label: "Support", to: "/support" },
];

// Shared shell for the legal and support pages: sticky header, content column, footer.
const LegalLayout = ({ title, testId, children }) => {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} | Thryvin'`;
    return () => {
      document.title = previous;
    };
  }, [title]);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="container">
          <Link to="/" className="back-link" data-testid="back-to-home-link">
            <ArrowLeft size={20} />
            <span>Back to Home</span>
          </Link>
          <img src={LOGO_URL} alt="Thryvin'" className="legal-logo" />
        </div>
      </header>

      <main className="legal-content" data-testid={testId}>
        <div className="container">{children}</div>
      </main>

      <footer className="legal-footer">
        <div className="container">
          <nav className="legal-footer-links" aria-label="Legal">
            {LEGAL_LINKS.map((link) => (
              <Link key={link.to} to={link.to}>
                {link.label}
              </Link>
            ))}
          </nav>
          <p>© {new Date().getFullYear()} Thryvin'. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LegalLayout;
